import { FC } from 'react';
import Image from 'next/image';
import { HeartButton } from './HeartButton.style';
const HeartButtonSkeleton: FC = () => {
  return <HeartButton active>
            <Image src="/icons/heart-button/grey-heart-button.svg" alt="share icon" width={24} height={24} />
        </HeartButton>;
};
export default HeartButtonSkeleton;